import { BuildClass, Do, timer } from '../../universal';
import { React, _ } from '../lib';
import { J2rModalPortal, j2r, j2rtxt } from './component-react';
import { ConditionalObject } from './ui5';
export class J2rDropdownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hidden: false };
    }
    render() {
        return j2r({
            key: 'top-level',
            cl: BuildClass({
                cmpt_dropdown: true,
                clickable: this.props.onClick != null,
            }),
            children: [
                {
                    tag: 'span',
                    key: 'top-level-inner',
                    children: [
                        ConditionalObject(this.props.icon != null, {
                            tag: 'img',
                            key: 'icon',
                            src: this.props.icon,
                        }),
                        {
                            tag: 'span',
                            key: 'lbl',
                            cl: 'lbl',
                            text: this.props.label,
                        },
                        ConditionalObject(this.props.items != null, {
                            tag: 'span',
                            cl: 'caret',
                            key: 'caret',
                            text: '▼',
                        }),
                    ],
                    onClick: () => (this.props.onClick ?? _.noop)(),
                },
                ConditionalObject(this.props.items != null, () => this.getChildren(this.props.items, this.props.label)),
            ],
        });
    }
    getChildren(options, parent_lbl) {
        return {
            key: 'dropdown-content',
            cl: 'dropdown-content',
            style: this.state.hidden ? { display: 'none' } : undefined,
            children: _.compact(_.map(options, (option, index) => {
                if (option == null || option.hidden) {
                    return null;
                }
                if (typeof option === 'string' && option[0] === '-') {
                    return {
                        tag: 'hr',
                        key: `sep-${index}`,
                    };
                }
                return {
                    key: `${parent_lbl}-child-${option.label}`,
                    cl: BuildClass({
                        'menu-item': true,
                        'sub-items': option.items != null,
                        disabled: option.onClick == null && option.items == null,
                        'no-handler': option.onClick == null,
                        hidden: this.state.hidden,
                    }),
                    children: Do(() => {
                        const C = [
                            {
                                key: option.label,
                                text: option.label,
                                title: option.title,
                                onClick: option.onClick == null
                                    ? _.noop
                                    : () => {
                                        this.setState({ hidden: true });
                                        timer(() => {
                                            this.setState({ hidden: false });
                                        });
                                        (option.onClick ?? _.noop)();
                                    },
                            },
                        ];
                        if (option.items != null) {
                            C.push(this.getChildren(option.items, option.label));
                        }
                        return C;
                    }),
                };
            })),
        };
    }
}
export class J2rDropdownMenuSet extends React.Component {
    container;
    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.state = {
            widths: null,
            expanded: false,
        };
    }
    componentDidMount() {
        this.setState({ widths: this.getWidths() });
    }
    componentDidUpdate() {
        const newWidths = this.getWidths();
        if (!_.isEqual(this.state.widths, newWidths)) {
            this.setState({ widths: newWidths });
        }
    }
    render() {
        return j2r({
            ref: this.container,
            cl: BuildClass({
                [this.props.cl]: true,
                'mobile-ellipsis-menu': this.isOverflow(),
            }),
            children: _.flatten([
                this.buildModal(),
                this.isOverflow()
                    ? {
                        tag: 'div',
                        onClick: () => {
                            this.setState({ expanded: true });
                        },
                        children: [
                            {
                                tag: 'img',
                                key: 'inner',
                                src: '/static/img/svg/ellipsis.svg',
                            },
                        ],
                    }
                    : this.getVisibleItems().map((x, i) => _.assign({ key: i }, x, { tag: J2rDropdownMenu })),
            ]),
        });
    }
    isOverflow() {
        return window.innerWidth <= (this.props.breakWidth ?? 768);
    }
    getVisibleItems() {
        if (this.props.constrainWidth) {
            const included = this.calculateVisibleItems();
            return this.props.items.slice(0, included);
        }
        return this.props.items;
    }
    calculateVisibleItems() {
        if (this.state.widths == null || this.container.current == null) {
            return this.props.items.length;
        }
        const availableWidth = this.container.current.getBoundingClientRect().width || 9999;
        let used_width = 0;
        const cumulative_widths = _.map(this.props.items, (_x, i) => {
            used_width += this.state.widths[i];
            return used_width + 0;
        });
        return _.size(_.filter(cumulative_widths, w => availableWidth - w > -1));
    }
    getWidths() {
        const widths = _.cloneDeep(this.state.widths ?? []);
        _.forEach(this.container.current?.children, (el, i) => (widths[i] = el.getBoundingClientRect().width));
        return widths;
    }
    buildModal() {
        return {
            tag: J2rModalPortal,
            key: 'modal',
            children: [
                {
                    key: 'inner-1',
                    cl: BuildClass({
                        noselect: true,
                        'menu-overflow-shade': true,
                        open: this.state.expanded,
                    }),
                    onClick: () => {
                        this.setState({ expanded: false });
                    },
                    children: [
                        {
                            key: 'inner-2',
                            cl: 'menu-overflow-shade-inner',
                            style: Do(() => {
                                const top = this.container.current?.getBoundingClientRect()
                                    .bottom ?? 0;
                                return { top: `${top + 2}px` };
                            }),
                            children: [
                                ConditionalObject(this.state.expanded, {
                                    tag: J2rDropdownMenuFlyout,
                                    key: 'inner-3',
                                    items: this.props.items,
                                    onClose: () => {
                                        this.setState({ expanded: false });
                                    },
                                }),
                            ],
                        },
                    ],
                },
            ],
        };
    }
}
class J2rDropdownMenuFlyout extends React.Component {
    constructor(props) {
        super(props);
        this.state = { items: this.props.items };
    }
    render() {
        return j2r({
            cl: 'menu',
            onClick: e => {
                e.stopPropagation();
                e.preventDefault();
            },
            children: _.map(this.state.items, (x, i) => ({
                key: x.key ?? i,
                cl: BuildClass({
                    'menu-item': true,
                    disabled: x.items == null && x.onClick == null,
                }),
                children: [
                    {
                        tag: 'span',
                        key: 'icon-wrapper',
                        cl: 'icon',
                        children: [
                            ConditionalObject(x.icon != null, {
                                tag: 'img',
                                key: 'icon',
                                src: x.icon,
                            }),
                        ],
                    },
                    {
                        tag: 'span',
                        cl: 'lbl',
                        key: 'lbl',
                        text: x.label,
                    },
                    ConditionalObject(x.items != null, {
                        tag: 'span',
                        cl: 'caret',
                        key: 'caret',
                        children: [j2rtxt('inner', '▼')],
                    }),
                ],
                onClick: () => {
                    if (x.items != null) {
                        this.setState({ items: x.items });
                    }
                    else if (x.onClick != null) {
                        x.onClick();
                        (this.props.onClose ?? _.noop)();
                    }
                },
            })),
        });
    }
}
//# sourceMappingURL=component-react-dropdown-menu.js.map